import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { ResourceService } from 'src/app/shared/resource-service'
import { environment } from 'src/environments/environment'
import { Role } from './role'
import { RoleSerializer } from './role.serializer'

@Injectable()
export class RoleService extends ResourceService<Role> {
  constructor(http: HttpClient, roleSerializer: RoleSerializer) {
    super(http, `${environment.backendApiUrl}/roles`, roleSerializer)
  }
}
